import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MLBFilterSection = ({ filters, onFilterChange, games }) => {
    const handleFilterChange = (key, value) => {
        onFilterChange({
            ...filters,
            [key]: value
        });
    };
    const clearFilters = () => {
        onFilterChange({
            team: '',
            confidence: 'ALL',
            pitcher: ''
        });
    };
    // Get unique teams from games
    const getUniqueTeams = () => {
        const teams = new Set();
        games.forEach(game => {
            const homeTeam = game.game_info?.home_team || game.home_team;
            const awayTeam = game.game_info?.away_team || game.away_team;
            if (homeTeam)
                teams.add(homeTeam);
            if (awayTeam)
                teams.add(awayTeam);
        });
        return Array.from(teams).sort();
    };
    // Get unique pitchers from games
    const getUniquePitchers = () => {
        const pitchers = new Set();
        games.forEach(game => {
            const homePitcher = game.game_info?.home_pitcher_name || game.home_pitcher;
            const awayPitcher = game.game_info?.away_pitcher_name || game.away_pitcher;
            if (homePitcher)
                pitchers.add(homePitcher);
            if (awayPitcher)
                pitchers.add(awayPitcher);
        });
        return Array.from(pitchers).sort();
    };
    const teams = getUniqueTeams();
    const pitchers = getUniquePitchers();
    return (_jsx("div", { className: "card mb-4", style: { backgroundColor: 'var(--card-bg)', borderColor: 'var(--card-border)' }, children: _jsx("div", { className: "card-body", children: _jsxs("div", { className: "row align-items-end", children: [_jsxs("div", { className: "col-md-3", children: [_jsxs("label", { htmlFor: "teamFilter", className: "form-label", children: [_jsx("i", { className: "fas fa-users me-1" }), "Team"] }), _jsxs("select", { id: "teamFilter", className: "form-select", value: filters.team, onChange: (e) => handleFilterChange('team', e.target.value), children: [_jsx("option", { value: "", children: "All Teams" }), teams.map(team => (_jsx("option", { value: team, children: team }, team)))] })] }), _jsxs("div", { className: "col-md-3", children: [_jsxs("label", { htmlFor: "confidenceFilter", className: "form-label", children: [_jsx("i", { className: "fas fa-chart-bar me-1" }), "Confidence Level"] }), _jsxs("select", { id: "confidenceFilter", className: "form-select", value: filters.confidence, onChange: (e) => handleFilterChange('confidence', e.target.value), children: [_jsx("option", { value: "ALL", children: "All Confidence Levels" }), _jsx("option", { value: "HIGH", children: "High Confidence" }), _jsx("option", { value: "MEDIUM_PLUS", children: "Medium-Plus Confidence" }), _jsx("option", { value: "MEDIUM", children: "Medium Confidence" }), _jsx("option", { value: "LOW", children: "Low Confidence" }), _jsx("option", { value: "NO_BET", children: "Avoid" })] })] }), _jsxs("div", { className: "col-md-3", children: [_jsxs("label", { htmlFor: "pitcherFilter", className: "form-label", children: [_jsx("i", { className: "fas fa-baseball-ball me-1" }), "Pitcher"] }), _jsxs("select", { id: "pitcherFilter", className: "form-select", value: filters.pitcher, onChange: (e) => handleFilterChange('pitcher', e.target.value), children: [_jsx("option", { value: "", children: "All Pitchers" }), pitchers.map(pitcher => (_jsx("option", { value: pitcher, children: pitcher }, pitcher)))] })] }), _jsx("div", { className: "col-md-3", children: _jsxs("button", { className: "btn btn-outline-secondary w-100", onClick: clearFilters, children: [_jsx("i", { className: "fas fa-times me-1" }), "Clear Filters"] }) })] }) }) }));
};
export default MLBFilterSection;
